<!-- 已报价列表 -->
<!-- offerOrNot: 1 Enquiry/querySupplierOfferList-->
<template>
  <div>
    <havePriced :query="{ offerOrNot: 1 }" back="/emergencyHavePrice" />
  </div>
</template>

<script>
import havePriced from './components/havePriced.vue';

export default {
  name: 'HavePrice',
  components: { havePriced },
};
</script>
<style lang="scss" scoped></style>
